import { Inject, OnInit } from '@angular/core';
import {
  IApplication,
  ISelectorHeader,
} from '@platform500services/p500-ui-kit/widgets/applications-selector/applications-selector.interfaces';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { BrowserWindowRef } from '../../../services/window/window.service';
import { IEnvironmentService } from '../../../services/environment/environment.interface';
import { IApplicationsService } from '../../../services/applications/applications.interfaces';
import { Directive } from '@angular/core';
import { IDataService, IParsedDataResponse } from '../../../services/data/data-service.interface';

@Directive({})
@DestroySubscribers()
// tslint:disable-next-line: directive-class-suffix
export abstract class AppSelectorBaseComponent implements OnInit {
  private subscribers: any = {};
  header: ISelectorHeader;
  urlControl: string;
  applications: IApplication[];
  private globalData: IParsedDataResponse;

  constructor(
    @Inject(BrowserWindowRef) protected window: BrowserWindowRef,
    @Inject('IEnvironmentService') protected envService: IEnvironmentService,
    @Inject('IApplicationsService') protected applicationsService: IApplicationsService,
    @Inject('IDataService') private dataService: IDataService
  ) {
    this.globalData = this.dataService.getData();
  }

  ngOnInit(): void {
    const isProduction = this.envService.getVar('production') as boolean;
    const host = isProduction ? this.window.nativeWindow.location.host : (this.envService.getVar('services.api') as string);
    const hostParsed = host.split('.');
    this.urlControl = `https://control.${hostParsed.length > 1 ? hostParsed[1] : hostParsed[0]}.com`;
    this.subscribers.application = this.applicationsService.getData().subscribe((applications) => {
      const [firstApplication] = applications;
      if (firstApplication) {
        this.header = {
          title: firstApplication.name,
          subtitle: firstApplication.type?.replace('-', ' '),
        };
        if (this.header.subtitle === 'partner platform') {
          this.header.subtitle = $localize`:@@common.partner_platform:Partner Platform`;
        }
      }
      this.applications = applications.slice(1).map((app) => ({
        ...app,
        url: app.url + `/${this.globalData.current_language}/master`,
      }));
    });
  }
}
